$(document).ready(function () {
  var face_look = 0;
  var improve = 0;
  var tried = "";           // "0" for Yes, "1" for No
  var current_question = 0;
  var chosen;
  var score = 60;
  var fname = "";
  var answers;
  var selected = false;

  var questions = [
    {
      question: "What is your age?",
      options: [
        { option: "16 – 25", value: 0 },
        { option: "26 – 35", value: -2 },
        { option: "35 – 45", value: -5 },
        { option: "45 – 60", value: -8 },
        { option: "60+",   value: -10 }
      ]
    },
    {
      question: "What does a typical meal look like?",
      options: [
        { option: "Chicken and salad", value: 5 },
        { option: "Burgers and fries",  value: -5 },
        { option: "Frozen food",        value: 0 },
        { option: "Beer and take out",  value: -5 }
      ]
    },
    {
      question: "How many hours of sleep do you get a night?",
      options: [
        { option: "1 - 4", value: -5 },
        { option: "5 - 6", value: 0 },
        { option: "7+",     value: 1 }
      ]
    },
    {
      question: "How many glasses of water do you drink daily?",
      options: [
        { option: "1 - 3", value: -4 },
        { option: "4 - 5", value: 1 },
        { option: "6 - 7", value: 3 },
        { option: "8+",    value: 5 }
      ]
    },
    {
      question: "At the end of the day, does your face look:",
      options: [
        { option: "Dry or parched",          value: 0 },
        { option: "Same as when you woke up", value: 0 },
        { option: "Oily or shiny",           value: 0 }
      ]
    },
    {
      question: "How often do you exfoliate?",
      options: [
        { option: "Every day",            value: -2 },
        { option: "Weekly",               value: 3 },
        { option: "A few times a month",  value: 0 },
        { option: "Never",                value: -2 }
      ]
    },
    {
      question: "Do you smoke?",
      options: [
        { option: "Yes", value: -10 },
        { option: "No",  value: 5 }
      ]
    },
    {
      question: "What about your skin would you most like to improve?",
      options: [
        { option: "Fine lines and wrinkles", value: 0 },
        { option: "",                         value: 0 },
        { option: "Daily skin care",          value: 0 },
        { option: "Tired eyes",               value: 0 },
        { option: "Oily skin",                value: 0 },
        { option: "Even skin tone",           value: 0 },
        { option: "Large pores",              value: 0 },
        { option: "",                         value: 0 }
      ]
    },
    {
      question: "What does your current skin care routine look like?",
      options: [
        { option: "I don’t have one",                                           value: -4 },
        { option: "I use some face wash",                                       value: 0 },
        { option: "I wash my face, moisturize, and maybe use a few other products", value: 5 },
        { option: "I have a full routine that includes daily skin care and anti aging", value: 5 }
      ]
    },
    {
      question: "Have you tried Brickell Men's Products before?",
      options: [
        { option: "Yes", value: 0 },
        { option: "No",  value: 0 }
      ]
    }
  ];

  var articles = [
    [
      {
        title: "Skin Care Routine for Men With Dry Skin",
        link: "/blogs/grooming-manual/89761155-skin-care-routine-for-men-with-sensitive-or-dry-skin"
      },
      {
        title: "The Top 5 Anti Aging Tips for Men",
        link: "/blogs/grooming-manual/66267203-top-5-anti-aging-tips-for-men"
      }
    ],
    [
      {
        title: "A Men's Skin Care Routine",
        link: "/blogs/grooming-manual/67369987-advanced-mens-skin-care-routine"
      },
      {
        title: "The Top 5 Anti Aging Tips for Men",
        link: "/blogs/grooming-manual/66267203-top-5-anti-aging-tips-for-men"
      }
    ],
    [
      {
        title: "How to Prevent Excess Oily Skin",
        link: "/blogs/grooming-manual/86457667-men-how-to-prevent-excess-oily-skin"
      },
      {
        title: "A Men's Skin Care Routine",
        link: "/blogs/grooming-manual/67369987-advanced-mens-skin-care-routine"
      }
    ]
  ];

  var customs_face = [
    [
      {
        text: 'Our <a href="/products/face-wash-for-men">Purifying Charcoal Face Wash</a> to cleanse skin while hydrating and not over drying.',
        id:  "face-wash-for-men"
      },
      {
        text: 'Our <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> hydrates your skin for all day moisture.',
        id:  "mens-face-moisturizer"
      },
      {
        text: 'Our <a href="/products/reviving-day-mens-face-serum">Reviving Day Serum</a> provides nutrients to deep down skin cells, while stimulating collagen production.',
        id:  "reviving-day-mens-face-serum"
      }
    ],
    [
      {
        text: 'Our <a href="/products/balancing-toner-for-men">Balancing Toner</a> to even out skin tone and minimize pores.',
        id:  "balancing-toner-for-men"
      },
      {
        text: 'Our <a href="/products/clarifying-gel-face-wash-for-men">Clarifying Gel Face Wash</a> to help remove impurities and leave the face feeling refreshed.',
        id:  "clarifying-gel-face-wash-for-men"
      },
      {
        text: 'Our <a href="/products/mens-face-scrub">Renewing Face Scrub</a> to remove dead skin, impurities and pore build up.',
        id:  "mens-face-scrub"
      },
      {
        text: 'Our lightweight <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> to add hydration without shine.',
        id:  "mens-face-moisturizer"
      }
    ],
    [
      {
        text: 'Our <a href="/products/clarifying-gel-face-wash-for-men">Clarifying Gel Face Wash</a> to help remove oil and prevent shine.',
        id:  "clarifying-gel-face-wash-for-men"
      },
      {
        text: 'Our <a href="/products/mens-face-scrub">Renewing Face Scrub</a> to remove dead skin, impurities and pore build up.',
        id:  "mens-face-scrub"
      },
      {
        text: 'Our <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> to add hydration without shine.',
        id:  "mens-face-moisturizer"
      }
    ]
  ];

  var skin_type = ["dry", "normal", "oily/combo"];

  var customs_improve = [
    {
      title: "We recommend one of our serums:",
      products: [
        {
          name:   "Reviving Day Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
          link:   "/products/reviving-day-mens-face-serum",
          id:     9344633486
        },
        {
          name:   "Repairing Night Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
          link:   "/products/repairing-night-mens-face-serum",
          id:     9344403278
        },
        {
          name:   "Daily Defense Face Moisturizer",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/2oz_Daily_Defense_Face_Moisturizer_855767007706.png?v=1544714993",
          link:   "/products/best-mens-face-moisturizer-with-spf",
          id:     1319914111051
        }
      ]
    },
    {
      title: "We recommend our serums and anti aging cream:",
      products: [
        {
          name:   "Reviving Day Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
          link:   "/products/reviving-day-mens-face-serum",
          id:     9344633486
        },
        {
          name:   "Repairing Night Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
          link:   "/products/repairing-night-mens-face-serum",
          id:     9344403278
        },
        {
          name:   "Revitalizing Anti-Aging Cream",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/AntiAgingCream_2048_Rev1_grande.png",
          link:   "/products/anti-aging-cream-for-men",
          id:     331270471
        }
      ]
    },
    {
      title: "We recommend our Daily Advanced Skin Care Routine:",
      products: [
        {
          name:   "Men's Daily Advanced Face Care Routine",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_skincare_set_1024x1024_49b908f9-a78b-4382-bbb7-d0e152706ca2_grande.png",
          link:   "/products/mens-daily-advanced-face-care-routine-i",
          id:     10022865870
        },
        {
          name:   "Daily Defense Face Moisturizer",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/2oz_Daily_Defense_Face_Moisturizer_855767007706.png?v=1544714993",
          link:   "/products/best-mens-face-moisturizer-with-spf",
          id:     1319914111051
        }
      ]
    },
    {
      title: "We recommend our Restoring Eye Balm:",
      products: [
        {
          name:   "Restoring Eye Cream",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Brickell_Restoring_Eye_Balm_.5oz.png",
          link:   "/products/best-eye-cream-for-men",
          id:     413218603
        }
      ]
    },
    {
      title: "We recommend our Clarifying Gel Cleanser:",
      products: [
        {
          name:   "Clarifying Gel Face Wash",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/best_face_wash_for_men_grande.png",
          link:   "/products/clarifying-gel-face-wash-for-men",
          id:     450323531
        },
        {
          name:   "Balancing Toner",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png",
          link:   "/products/balancing-toner-for-men",
          id:     1331683885131
        }
      ]
    },
    {
      title: "We recommend our Advanced Anti Aging Routine:",
      products: [
        {
          name:   "Reviving Day Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
          link:   "/products/reviving-day-mens-face-serum",
          id:     9344633486
        },
        {
          name:   "Repairing Night Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
          link:   "/products/repairing-night-mens-face-serum",
          id:     9344403278
        },
        {
          name:   "Advanced Anti Aging Routine",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_Group_1024x1024_7e317f6f-6605-402f-b515-d3e620df83ff_grande.png",
          link:   "/products/advanced-anti-aging-routine",
          id:     9441347918
        },
        {
          name:   "Balancing Toner",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png?v=1544726653",
          link:   "/products/balancing-toner-for-men",
          id:     1331683885131
        }
      ]
    },
    {
      title: "We recommend our Daily Advanced Skin Care Routine:",
      products: [
        {
          name:   "Men's Daily Advanced Face Care Routine",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_skincare_set_1024x1024_49b908f9-a78b-4382-bbb7-d0e152706ca2_grande.png",
          link:   "/products/mens-daily-advanced-face-care-routine-i",
          id:     10022865870
        },
        {
          name:   "Balancing Toner",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png?v=1544726653",
          link:   "/products/balancing-toner-for-men",
          id:     1331683885131
        }
      ]
    }
  ];

  if (Cookies.get("score")) {
    console.log("Loaded from cookies:", Cookies.get("score"), Cookies.get("fname"));
    score     = Math.floor(Cookies.get("score"));
    fname     = Cookies.get("fname");
    improve   = Cookies.get("improve");
    face_look = Cookies.get("face_look");
    tried     = Cookies.get("tried"); // "0" or "1"
    showResults();
    $(".results").show();
    $(".question, .introduction").hide();
  }

  $("#content").css("border-bottom", 0).css("padding-top", 0);

  $(".start").click(function () {
    answers = [];
    $(".test-progress h5").text("1 of 10");
    $(".back").hide();
    $(".skin-test").addClass("started");
    $(".introduction").hide();
    var questionObj = questions[current_question];
    $(".question").not(".email").show();
    $(".question h4").text(questionObj.question);
    loadQuestions(questionObj);
  });

  $(".retake a").click(function (e) {
    e.preventDefault();
    Cookies.remove("score");
    Cookies.remove("fname");
    Cookies.remove("improve");
    Cookies.remove("tried");
    Cookies.remove("face_look");
    score            = 60;
    answers          = [];
    tried            = "";
    current_question = 0;
    $(".options").empty();
    $(".introduction").show();
    $(".results").hide();
    $("section.k3, section.k2").hide();
    $(".recommended-articles .articles").empty();
  });

  $(".back").click(function () {
    $(".option.selected").removeClass("selected");
    if (face_look == 0 && current_question == 5) {
      questions[8].options = [
        { option: "Fine lines and wrinkles", value: 0 },
        { option: "Firmer, tighter look",      value: 0 },
        { option: "Daily skin care",           value: 0 },
        { option: "Tired eyes",                value: 0 },
        { option: "Oily skin",                 value: 0 },
        { option: "Even skin tone",            value: 0 },
        { option: "Large pores",               value: 0 }
      ];
    }

    current_question--;
    $(".test-progress h5").text(current_question + 1 + " of 10");
    if (current_question == 0) {
      $(".back").hide();
    }
    score -= questions[current_question].options[answers[current_question]].value;
    var questionObj = questions[current_question];
    $(".question h4").text(questionObj.question);
    $(".options").empty();
    loadQuestions(questionObj);
    answers.pop();
  });

  function showResults() {
    console.log("tried =", tried);
    Cookies.set("taken", 1);

    // Build the base score text
    var scoreText = "";
    if (score <= 20) {
      scoreText = "Your skin is in very bad shape. You need to change your lifestyle and upgrade your skin care routine.";
    } else if (score >= 21 && score <= 40) {
      scoreText = "Your skin is not in good shape.";
    } else if (score >= 41 && score <= 60) {
      scoreText = "Your skin is in ok shape.";
    } else if (score >= 61 && score <= 80) {
      scoreText = "You have decent skin but there is room for improvement.";
    } else if (score >= 81 && score <= 90) {
      scoreText = "Your skin is in good shape but there is room for improvement.";
    } else if (score > 90) {
      scoreText = "Your skin is in excellent shape.";
    }

    var result = "";

    // NO branch: tried === "1"
    if (tried === "1") {
      // Score + Free Sample Kit message
      result = scoreText +
        '<br>Based on your answers, we recommend the below products <b>and trying our <a href="/collections/shop-with-new20">Free Sample Kit</a> that comes with $110 in Free Gifts!</b>';

      // 1) Show the suggested-container wrapper
      $(".custom-face .suggested-container").show();

      // 2) Hide all product cards, then show new20_add + first 3 face products
      $(".custom-face .suggested-container .product").hide();
      $(".custom-face .suggested-container .new20_add").show();
      for (var i = 0; i < 3; i++) {
        var pid = customs_face[face_look][i].id;
        $(".custom-face .suggested-container .product." + pid).show();
      }

      // 3) Hide the header
      $(".results .custom-face > h6.title").hide();

      // 4) Show sample-kit-container if needed
      $(".custom-face .sample-kit-container").show();

      // 5) Hide anything else
      $(".custom-improve").hide();
      $(".skin-test").addClass("tried");

    } else {
      // YES branch: tried === "0"
      // Only show scoreText in result; header lives in h6.title
      result = scoreText;

      // Show the recommendation header
      $(".results .custom-face > h6.title")
        .show()
        .html(
          "Based on your answers and your " +
          skin_type[face_look] +
          " skin, we recommend these products:"
        );

      // Hide all product cards, then show those matching this skin type
      $(".custom-face .suggested-container .product").hide();
      for (var j = 0; j < customs_face[face_look].length; j++) {
        var pid2 = customs_face[face_look][j].id;
        $(".custom-face .suggested-container .product." + pid2).show();
      }

      // Hide new20_add if it exists
      $(".custom-face .suggested-container .new20_add").hide();

      // Hide sample-kit-container
      $(".custom-face .sample-kit-container").hide();

      // Show or hide the improve section
      if (improve == 7) {
        $(".custom-improve").hide();
      } else {
        $(".custom-improve").show();
        $(".custom-improve h3").text(
          "To help with your objective of " +
            questions[7].options[improve].option +
            ", we suggest learning more about the following products:"
        );
        $(".results .custom-improve .products").empty();
        for (var k = 0; k < customs_improve[improve].products.length; k++) {
          $(".results .custom-improve .products").append(
            "<div class='product span3'><img src='" +
              customs_improve[improve].products[k].picture +
              "'><h3>" +
              customs_improve[improve].products[k].name +
              "</h3><div class='yotpo bottomLine' data-appkey='HB2ysZp6ROjiio3fXMJ9LrRGvuyn37u7yRzh3BC2' data-domain='{{ shop.permanent_domain | escape }}' data-product-id='" +
              customs_improve[improve].products[k].id +
              "' data-product-models='" +
              customs_improve[improve].products[k].id +
              "'></div><a href='" +
              customs_improve[improve].products[k].link +
              "' class='button'>Add to Cart</a></div>"
          );
        }
      }

      $(".skin-test").removeClass("tried");
    }

    // Populate the two elements inside .skin-test-padding
    $(".skin-test-padding h4").text(
      "Hey " + fname + ", your score is: " + score + " out of 100"
    );
    $(".skin-test-padding h5.score-details").html(result);
  }

  function loadQuestions(questionObj) {
    for (var j = 0; j < questionObj.options.length; j++) {
      if (questionObj.options[j].option !== "") {
        $(".options").append(
          "<div class='option'><input type='radio' style='display:none;' id='" +
            j +
            "" +
            current_question +
            "' value='" +
            j +
            "' name='" +
            current_question +
            "' /><label for='" +
            j +
            "" +
            current_question +
            "'>" +
            questionObj.options[j].option +
            "</label></div>"
        );
      }
    }

    $("input[name='" + current_question + "']").change(function () {
      if (!selected) {
        $(this).parent().addClass("selected");
      }
      selected = true;

      setTimeout(function () {
        var val = $("input[name='" + current_question + "']:checked").val();
        if (!isNaN(parseInt(val))) {
          chosen = parseInt(val);
          answers.push(chosen);
          $(".back").show();

          switch (current_question) {
            case 4:
              face_look = chosen;
              if (chosen == 0) {
                questions[7].options[4].option = "";
                questions[7].options[6].option = "";
              } else {
                questions[7].options[4].option = "Oily skin";
                questions[7].options[6].option = "Large pores";
              }
              break;
            case 7:
              improve = chosen;
              break;
            case 9:
              // Save "0" or "1" for Yes/No
              tried = chosen.toString();
              break;
          }

          score += questionObj.options[chosen].value;
          current_question++;
          $(".test-progress h5").text(current_question + 1 + " of 10");

          if (current_question == questions.length) {
            $(".question").hide();

            if (Cookies.get("taken") != "1") {
              $(".email h2").text("What is your first name and email address?");
              $(".email.question").show();
              $(".email.question form").submit(function (e) {
                if (
                  $("#quiz_signup input[name=first_name]").val() === "" ||
                  $("#quiz_signup input[name=email]").val() === ""
                ) {
                  return;
                }
                $(".email.question").hide();
                $(".results").show();
                fname = $("input[name='first_name']").val();
                Cookies.set("fname", fname);
                Cookies.set("tried", tried);
                Cookies.set("score", score);
                Cookies.set("face_look", face_look);
                Cookies.set("improve", improve);
                showResults();
              });
            } else {
              $(".results").show();
              fname = $("input[name='first_name']").val();
              Cookies.set("fname", fname);
              Cookies.set("tried", tried);
              Cookies.set("score", score);
              Cookies.set("face_look", face_look);
              Cookies.set("improve", improve);
              showResults();
            }
          } else {
            var nextQuestion = questions[current_question];
            $(".question h4").text(nextQuestion.question);
            $(".options").empty();
            loadQuestions(nextQuestion);
          }
        }
        selected = false;
      }, 500);
    });
  }
});
